export const EHRInstanceTypes = ['epic', 'cerner', 'deploy'];
//# sourceMappingURL=types.js.map